import {
  BACKGROUND,
  FREE_TO_EDIT,
  PERSONAL_LICENSE,
  PHOTO,
  PREMIUM,
  STICKER,
  SHAPE,
  TEXT,
  TEXT_STYLE,
} from 'configs/constants';
import { TAnyObject } from 'types';

const freeLicenses = [FREE_TO_EDIT, PERSONAL_LICENSE];

const checkIsPremium = (item: TAnyObject) => {
  if (!item) return;

  switch (item.type) {
    case PHOTO:
    case STICKER:
    case BACKGROUND:
      return item.is_paid ?? (!!item.license && !freeLicenses.includes(item.license));
    case TEXT:
      return item.license === PREMIUM;
    case SHAPE:
    case TEXT_STYLE:
      return item.license === PREMIUM || item.is_paid;
    default:
      return item.is_paid; // background, collage_bg, photo_templates, text_styles, font, sticker (not fte).
  }
};
export default checkIsPremium;
